import { Box, Button, Modal, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { modalStyles, useStyles } from "./FeatureToggleConfirmModal.styles";

export interface IFeatureToggleConfirmModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    title: string;
    description: string;
    confirmLabel: string;
    confirmButtonColor?: "info" | "success" | "error" | "warning";
    cancelLabel?: string;
}

const FeatureToggleConfirmModal = ({
    open,
    onClose,
    onConfirm,
    title,
    description,
    confirmLabel,
    confirmButtonColor = "info",
    cancelLabel,
}: IFeatureToggleConfirmModalProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const handleConfirm = async () => {
        await onConfirm();
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose} disableEscapeKeyDown keepMounted={false}>
            <Box sx={modalStyles}>
                <div className={classes.modalHeader}>{title}</div>
                <div className={classes.modalBody}>
                    <Typography className={classes.description}>{description}</Typography>
                </div>
                <div className={classes.footer}>
                    <Button
                        variant="outlined"
                        color="info"
                        className={classes.submitButton}
                        onClick={onClose}
                    >
                        {cancelLabel ?? t("main_modal.cancel_button")}
                    </Button>
                    <Button
                        variant="contained"
                        color={confirmButtonColor}
                        className={classes.submitButton}
                        onClick={handleConfirm}
                    >
                        {confirmLabel}
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default FeatureToggleConfirmModal;
